import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  APP,
  AppStateType,
  LanguageEnum,
  SimulatedRole,
  ToastMessage,
} from "./appTypes";

const initialState: AppStateType = {
  toastMessage: null,
  language: LanguageEnum.EN,
  sidebarCollapsed: false,
  simulatedRole: null,
};

export const appSlice = createSlice({
  name: APP,
  initialState,
  reducers: {
    resetAppAll: (state: AppStateType) => {
      state = initialState;
      return state;
    },
    setToastMessage: (state, action: PayloadAction<ToastMessage>) => {
      state.toastMessage = action.payload;
    },
    clearToastMessage: (state) => {
      state.toastMessage = null;
    },
    setLanguage: (state, action: PayloadAction<LanguageEnum>) => {
      state.language = action.payload;
    },
    setSidebarCollapsed: (state, action: PayloadAction<boolean>) => {
      state.sidebarCollapsed = action.payload;
    },
    toggleSidebar: (state) => {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
    setSimulatedRole: (state, action: PayloadAction<SimulatedRole | null>) => {
      state.simulatedRole = action.payload;
    },
    clearSimulatedRole: (state) => {
      state.simulatedRole = null;
    },
  },
});

export const {
  resetAppAll,
  setToastMessage,
  clearToastMessage,
  setLanguage,
  setSidebarCollapsed,
  toggleSidebar,
  setSimulatedRole,
  clearSimulatedRole,
} = appSlice.actions;

export default appSlice.reducer;
